import pancakeSwapImg from "src/assets/images/buyTrava/PancakeSwap.png";
import uniswapImg from "src/assets/images/buyTrava/UniSwap.png";
import spookySwapImg from "src/assets/images/buyTrava/SpookySwap.png";
import bitmartImg from "src/assets/images/buyTrava/Bitmart.png";
import mexcImg from "src/assets/images/buyTrava/Mexc.png";

export const exchanges = [
  {
    id: "psc",
    title: "PancakeSwap",
    link: "https://pancakeswap.finance/swap?outputCurrency=0x0391be54e72f7e001f6bbc331777710b4f2999ef",
    img: pancakeSwapImg,
  },
  {
    id: "uns",
    title: "UniSwap",
    link: "https://pancakeswap.finance/swap?outputCurrency=0x0391be54e72f7e001f6bbc331777710b4f2999ef",
    img: uniswapImg,
  },
  {
    id: "sks",
    title: "SpookySwap",
    link: "https://spookyswap.finance/swap?outputCurrency=0x477a9d5df9beda06f6b021136a2efe7be242fcc9",
    img: spookySwapImg,
  },
  {
    id: "bitmart",
    title: "Bitmart",
    link: "https://www.bitmart.com/trade/en?symbol=TRAVA_USDT&layout=basic",
    img: bitmartImg,
  },
  {
    id: "mexc",
    title: "MEXC",
    link: "https://www.mexc.com/exchange/TRAVA_USDT",
    img: mexcImg,
  },
];

export const suggestionsConfig = [
  {
    title: "Buy and stake TRAVA in our vaults",
    link: "https://app.trava.finance/staking",
    text: "Staking",
  },
  {
    title: "Deposit and borrow TRAVA in our lending pools",
    link: "https://app.trava.finance/",
    text: "Lending Pool",
  },
  {
    title: "Buy and stake NFT",
    link: "https://nft-app.trava.finance/",
    text: "NFT",
  },
];
